import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import close from './close.js'
import opener from './opener.js'

export default contract({
  close: array([
    close
  ]),
  opener: array([
    opener
  ])
})
